<template>
    <div class="trade-symbols">
        <div class="d-flex flex-wrap justify-start align-center w-full">
            <div v-for="(symbol, index) in trades.topSymbols" :key="index" class="chart-wrapper">
                <v-card tile flat class="pb-0" :class="$vuetify.theme.dark ? 'blue-lighten-1' : 'white-lighten-2'">
                    <div class="chart-container">
                        <apexcharts :ref="`chart-${index}`" type="donut" :width="230" :height="300"
                            :options="getChartOptions(symbol, index)"
                            :series="[symbol.percentage, 100 - symbol.percentage]"></apexcharts>
                        <div class="center-text">{{ symbol.count }} = {{ symbol.percentage }}%</div>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    props: {
        trades: {
            type: Object,
            default: () => ({
                totalTrades: 0,
                topSymbols: []
            })
        }
    },
    components: {
        apexcharts: VueApexCharts,
    },
    data() {
        return {
            colors: [
                "#B2C34A",
                "#FFB547",
                "#47B5FF",
                "#FF47B5"
            ]
        }
    },
    mounted() {
        this.initializeCharts();
    },
    methods: {
        initializeCharts() {
            this.$nextTick(() => {
                this.trades.topSymbols.forEach((_, index) => {
                    this.addMarginToLegendMarkers(index);
                    this.hideLastLegendItem(index);
                });
            });
        },
        hideLastLegendItem(index) {
            const chartRef = this.$refs[`chart-${index}`];
            if (chartRef && chartRef[0]) {
                const legendItems = chartRef[0].$el.querySelectorAll('.apexcharts-legend-series');
                if (legendItems.length > 0) {
                    const lastLegendItem = legendItems[legendItems.length - 1];
                    lastLegendItem.style.display = 'none';
                }
            }
        },
        addMarginToLegendMarkers(index) {
            const chartRef = this.$refs[`chart-${index}`];
            if (chartRef && chartRef[0]) {
                const legendMarkers = chartRef[0].$el.querySelectorAll('.apexcharts-legend-marker');
                legendMarkers.forEach(marker => {
                    marker.style.marginRight = '10px';
                });
            }
        },
        getChartOptions(symbol, index) {
            return {
                colors: [this.colors[index], "#21354E"],
                legend: {
                    position: "top",
                    horizontalAlign: 'left',
                    fontSize: "14px",
                    fontFamily: "Inter",
                    fontWeight: 400,
                    offsetY: 10,
                    labels: {
                        colors: "#708AA7",
                    },
                    markers: {
                        width: 10,
                        height: 10,
                    },
                    itemMargin: {
                        horizontal: 5,
                    },
                },
                stroke: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                labels: [symbol.symbol, ""],
            };
        }
    }
};
</script>

<style scoped>
.center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    font-weight: 500;
    color: #708AA7;
    line-height: 26px;
}
</style>